import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import ContactModal from "../ContactModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  anchorPosition,
  ticketId,
}) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [hubspotModalOpen, setHubspotModalOpen] = useState(false);
  const [hubspotContactId, setHubspotContactId] = useState(null);
  const [hubspotDescription, setHubspotDescription] = useState("");

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleSaveDescriptionToHubSpot = async () => {
    handleClose();
    const messageBody = message.body || "";

    try {
      const { data: ticketData } = await api.get(`/tickets/${ticketId}`);
      const contactId = ticketData?.contact?.id;
      if (!contactId) return;

      const { data: checkData } = await api.get(`/hubspot/check/${contactId}`);

      if (checkData.exists) {
        await api.post(`/hubspot/update-description/${contactId}`, {
          description: messageBody,
        });
        toast.success(i18n.t("messageOptionsMenu.hubspotDescriptionSaved"));
      } else {
        setHubspotContactId(contactId);
        setHubspotDescription(messageBody);
        setHubspotModalOpen(true);
      }
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      {hubspotContactId && (
        <ContactModal
          open={hubspotModalOpen}
          onClose={() => {
            setHubspotModalOpen(false);
            setHubspotContactId(null);
          }}
          contactId={hubspotContactId}
          initialValues={{ description: hubspotDescription }}
          saveToHubSpot={true}
        />
      )}
      <Menu
        anchorEl={anchorEl}
        anchorReference={anchorPosition ? "anchorPosition" : "anchorEl"}
        anchorPosition={anchorPosition || undefined}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {message.fromMe && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        {!message.fromMe && (
          <MenuItem onClick={handleSaveDescriptionToHubSpot}>
            {i18n.t("messageOptionsMenu.saveDescriptionToHubSpot")}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
